<template>
  <div id="team-content" v-if="page.team" :class="{'active': currentPage == 'team-content' || this.pageIsAutoScrolling}">
    <div class="section">
      <div class="section__main reduced-width">
        <div class="content content_team light-bg">
          <div class="team">
            <waterfall :line-gap="380" align="center" :watch="persons" ref="waterfall">
              <waterfall-slot
                v-for="(person, index) in persons.item"
                v-if="!person.$is_founder"
                :width="330"
                :height="330*person.card_size.$size"
                :order="index"
                :key="person.$id"
                :class="[isCurrentPerson(person.$id) && popupOpened ? 'selected' : 'deselected', getPersonsCardSize(person.card_size.$size)]"
                :style="checkCurrentPerson(person)"
                :ref="person.$id"
              >
                <div class="person" @click="setCurrentPerson(person.$id)">
                  <span class="person__back" @click.stop="resetCurrentPerson()">
                    <span class="icon-arrow-left"></span>
                    <span class="icon-exit"></span>
                  </span>
                  <div class="person__photo" v-if="person.background" :style="{backgroundImage: 'url(' + person.background.$src + ')'}">
                      <div v-if="person.photo" class="person__photo-img" :style="{backgroundImage: 'url(' + person.photo.$src + ')'}"></div>
                  </div>
                  <div class="person__info">
                    <div class="person__name">
                      {{ person.text.item.first_name }} {{ person.text.item.last_name }}
                    </div>
                    <div class="person__position">
                      {{ person.text.item.position }}
                    </div>
                    <div class="person__content" v-html="person.text.item.text_content"></div>
                  </div>
                </div>
              </waterfall-slot>
            </waterfall>
          </div>
          <div class="team__contacts" v-html="page.team.text_contacts"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Waterfall from 'vue-waterfall/lib/waterfall';
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot';

export default {
  name: 'teamContent',
  data() {
    return {
      isAnimated: false,
      cardSize: 2,
      personClicked: '',
      currentTop: 0,
      oldTop: 0,
    };
  },
  components: {
    Waterfall,
    WaterfallSlot,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    persons: 'persons',
    currentPerson: 'currentPerson',
    popupOpened: 'popupOpened',
    pageIsAutoScrolling: 'pageIsAutoScrolling',
  }),
  watch: {
    lang() {
      this.getData();
    },
    popupOpened() {
      if (!this.popupOpened) {
        this.resetCurrentPerson();
      }
    },
  },
  methods: {
    getPersonsCardSize(size) {
      let currentClass = '';

      if (size === 1.2) {
        currentClass = 'small';
      } else if (size === 1.5) {
        currentClass = 'medium';
      } else if (size === 1.6) {
        currentClass = 'large';
      }

      return currentClass;
    },
    isCurrentPerson(id) {
      return id === this.currentPerson;
    },
    setCurrentTop() {
      const teamTop = document.querySelector('.team').getBoundingClientRect().top;
      this.currentTop = -teamTop + 100;
    },
    setCurrentPerson(id) {
      this.$store.commit('SET_CURRENT_PERSON', id);
      this.oldTop = this.$refs[`${id}`][0].$el.style.top;
      this.personClicked = id;
      this.setCurrentTop();
      this.$store.commit('SET_POPUP_STATE', true);
    },
    resetCurrentPerson() {
      this.$store.commit('SET_CURRENT_PERSON', '');
      this.$store.commit('SET_POPUP_STATE', false);
      this.$refs.waterfall.$emit('reflow');
      setTimeout(() => {
        this.personClicked = '';
      }, 1000);
    },
    checkCurrentPerson(person) {
      if (this.isCurrentPerson(person.$id) && this.popupOpened) {
        return `top: ${this.currentTop}px`;
      }
      return `top: ${this.oldTop}px`;
    },
    getData() {
      this.$store.dispatch('fetchPersons', { lang: this.lang, $http: this.$http });
    },
  },
  mounted() {
    this.getData();
    window.addEventListener('keyup', (event) => {
      if (event.keyCode === 27 && this.currentPerson !== '') {
        this.resetCurrentPerson();
      }
    });
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @keyframes contentAnimation {
    0% {
      opacity: 0;
      transform: translateX(-30px);
    }
    70% {
      opacity: 0;
      transform: translateX(-30px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes contentAnimation2 {
    0% {
      opacity: 0;
      transform: translateX(-30px);
    }
    80% {
      opacity: 0;
      transform: translateX(-30px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .vue-waterfall {
    display: block;
    overflow: visible !important;

    &-slot {
      display: block;
      perspective: 300px;
      perspective-origin: 50% 0;
      z-index: 1;
      min-height: 0;
      transition: width 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), max-height 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), min-height 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), left 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), top 0.8s ease, z-index 0.8s ease;

      .person {
        max-height: 100%;
        transform: rotateX(-10deg);
        transform-origin: 50% 0;
        transition: transform 0.5s ease, opacity 0.8s ease, width 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), padding-top 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), opacity 0.8s ease, padding-bottom 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000), max-height 0.8s cubic-bezier(0.500, 0.000, 0.100, 1.000);
        padding-top: 0;
        padding-bottom: 0;
        margin: 0 25px;
        cursor: pointer;
        opacity: 0;

        #team-content.active & {
          transform: rotateX(0);
          opacity: 1;
        }

        &__info {
          position: relative;
          transition: left 0.5s ease 0.5s, opacity 0.5s ease 0.5s;
        }

        &__back {
          display: none;
          position: absolute;
          cursor: pointer;
          top: 50px;
          left: 100px;
          z-index: 2;
          animation: contentAnimation 1.1s ease forwards;

          .icon-arrow-left {
            position: relative;
            left: 0;
            transition: left 0.2s ease-in-out;

            &:before {
              font-size: 60px;
            }
          }

          .icon-exit {
            display: none;
            font-size: 25px;
          }

          &:hover {
            .icon-arrow-left {
              left: -20px;
            }
          }
        }

        &__name {
          font-family: 'UniversLTStdBold';
        }

        &__photo {
          width: 100%;
          height: 355px;
          background-color: #eee;
          overflow: hidden;
          position: absolute;
          background-size: cover;
          background-position: 0 0;
          background-repeat: no-repeat;
          top: 0;
          padding-bottom: 0;
          right: 0;
          transition: right 0.8s cubic-bezier(0.390, 0.000, 0.215, 0.995), top 0.8s cubic-bezier(0.390, 0.000, 0.215, 0.995), width 0.8s cubic-bezier(0.390, 0.000, 0.215, 0.995), transform 0.5s cubic-bezier(0.390, 0.000, 0.215, 0.995), max-height 0.8s cubic-bezier(0.390, 0.000, 0.215, 0.995), padding-bottom 0.8s cubic-bezier(0.390, 0.000, 0.215, 0.995);

          &-img {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: 0 0;
            background-repeat: no-repeat;
            position: absolute;
            z-index: 1;
          }

          &:before {
            content: '';
            position: absolute;
            border-bottom: 500px solid rgba(238, 46, 34, 0.6);
            border-right: 500px solid transparent;
            top: 100%;
            left: 100%;
            transition: all 0.5s cubic-bezier(0.600, 0.085, 0.050, 0.895);
          }

          &:hover {
            &:before {
              top: 0;
              left: 0;
            }
          }
        }

        &__content {
          display: none;
        }

        &__controls {
          display: none;
        }

        &__control {
          &.disabled {
            opacity: 0.5;
          }
        }
      }

      &.small {
        max-height: 475px;

        .person {
          padding-top: 370px;

          &__photo {
            padding-bottom: 107.58%;
          }
        }
      }

      &.medium {
        max-height: 555px;

        .person {
          padding-top: 450px;

          &__photo {
            padding-bottom: 131.82%;
          }
        }
      }

      &.large {
        max-height: 612px;

        .person {
          padding-top: 505px;

          &__photo {
            padding-bottom: 148.488%;
          }
        }
      }

      #team-content.active &.deselected {
        .person {
          &__info {
            animation: contentAnimation2 1s ease forwards;
          }
        }
      }
      
      &.selected {
        left: 0 !important;
        width: 100% !important;
        min-height: 70vh;
        max-height: 2000px;
        z-index: 11;

        .person {
          max-height: 2000px;
          cursor: auto;
          padding-top: 160px;
          padding-bottom: 100px;
          padding-left: 100px;
          padding-right: 100px;
          transform: rotateX(0);
          opacity: 1;
          background-color: $lightest-color;

          &__back {
            display: block;
          }

          &__info {
            width: 47%;
            max-height: 100%;
            height: 100%;
            overflow-y: auto;
            opacity: 0;
            animation: contentAnimation 1s ease forwards !important;
          }

          &__name {
            font-family: 'DietDidotTitleBold';
            font-size: 80px;
            line-height: 100%;
          }

          &__position {
            margin-bottom: 50px;
          }

          &__photo {
            position: absolute;
            top: -20px;
            right: -20px;
            bottom: 20px;
            margin: 0;
            width: 50%;
            padding-bottom: 66.66%;
            max-width: 800px;
            max-height: 1200px;

            &:before {
              display: none !important;
            }

            &-img {
              display: none !important;
            }
          }

          &__content {
            display: block;
          }

          &__controls {
            display: block;
          }
        }
      }
    }
  }

  .team__contacts {
    margin-top: 50px;
    padding-left: 55px;
    h2 {
      margin-bottom: 40px;
    }
  }

  @media (max-width: 1275px) {
    .vue-waterfall {
      &-slot {
        .person__back {
          left: 40px;
        }

        &.selected {
          .person {
            padding-left: 40px; 
            padding-right: 40px;

            &__name {
              font-size: 50px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 850px) {
    .team {
      margin: -20px -25px 0;
    }

    .vue-waterfall {
      height: auto !important;

      &-slot {
        position: relative !important;
        top: 0 !important;
        left: 0 !important;
        height: auto !important;
        width: auto !important;

        .person {
          margin: 0;
          padding: 20px 25px 0 !important;
          position: relative;

          &:after {
            content: '';
            display: block;
            clear: both;
          }

          &__back {
            left: auto;
            right: 0;
            top: 0;

            .icon-arrow-left {
              display: none;
            }

            .icon-exit {
              display: block;
            }
          }

          &__name {
            margin-right: 35px;
            line-height: 150%;
          }

          &__photo {
            width: 45%;
            padding-bottom: 45% !important;
            position: relative;
            overflow: hidden;
            height: auto !important;
            float: left;
            margin: 0 0 20px 0;

            &:before {
              display: none;
            }

            &-img {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }

          &__info {
            margin-left: 50%;
          }

          &__content {
            clear: both;
            margin-left: -100%;
            margin-bottom: 40px;
          }
        }

        &.deselected {
          .person {
            &__info {
              animation: none !important;
            }
          }
        }

        &.selected {
          .person {
            padding: 0;

            &__back {
              animation: none;
            }

            &__photo {
              position: relative;
              top: auto;
              left: auto;
              bottom: auto;
              right: auto;
              width: 45%;
              padding-bottom: 45%;
              margin: 0 0 20px 0;
            }

            &__info {
              width: 50%;
              overflow: visible;
              opacity: 1;
              animation: none !important;
            }

            &__name {
              font-size: 18px;
              line-height: 150%;
              font-family: 'UniversLTStdBold';
            }

            &__controls {
              display: none;
            }
          }
        }
      }
    }

    .team__contacts {
      padding-left: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/TeamContent.vue?55d6c011